import { render, staticRenderFns } from "./AccountsInformation.vue?vue&type=template&id=2e68d5fb&"
import script from "./AccountsInformation.vue?vue&type=script&lang=js&"
export * from "./AccountsInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports